const namespace = 'PROFILE';

export const SET_PROFILE_SETTINGS = `${namespace}/SET_PROFILE_SETTINGS`;
export const SET_PROFILE_SETTINGS_SUCCESS = `${namespace}/SET_PROFILE_SETTINGS_SUCCESS`;
export const SET_PROFILE_SETTINGS_ERROR = `${namespace}/SET_PROFILE_SETTINGS_ERROR`;

export const setProfileSettings = payload => {
  return async dispatch => {
    dispatch({ type: SET_PROFILE_SETTINGS, payload });
  };
};
